import { FetcherAmplify } from 'src/business/Libraries/Fetcher/FetcherAmplify';
import AffidavitRepositoryI from './AffidavitRepositoryI';
import { CustomerType } from 'blum-rivendell-frontend/dist/customer/domain/Customer';

export default class AffidavitRepository implements AffidavitRepositoryI {
  constructor(private fetcher: FetcherAmplify) {}

  public async create(
    customerId: string,
    employeeId: string,
    affidavitType?: string,
  ): Promise<any> {
    return this.fetcher.post('/v1/affidavits', {
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
        employeeId,
        ...(affidavitType && { affidavitType }),
      },
    });
  }

  public async update(
    customerId: string,
    metadata: any,
    affidavitType?: string,
  ): Promise<any> {
    return this.fetcher.put(`/v1/affidavits/${metadata.affidavitId}`, {
      body: {
        selectedSign: metadata.selectedSign,
        finalBeneficiaryStatementReviewedAndCorrect:
          metadata.finalBeneficiaryStatementReviewedAndCorrect,
        statementReviewedAndCorrect: metadata.statementReviewedAndCorrect,
      },
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
        ...(affidavitType && { affidavitType }),
      },
    });
  }
  public async get(
    customerId: string,
    onlyLast: boolean,
    affidavitType?: string,
  ): Promise<any> {
    return this.fetcher.get(`/v1/customers/${customerId}/affidavits`, {
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
        onlyLast,
        affidavitType,
      },
    });
  }
}
